import { defineMessages } from 'react-intl';

export const emailSubscriptionFormMessages = defineMessages({
	emailLabel: {
		id: 'uniform.emailSubscriptionForm.emailLabel',
		defaultMessage: 'Email address',
	},
	emailPlaceholder: {
		id: 'uniform.emailSubscriptionForm.emailPlaceholder',
		defaultMessage: 'Email address',
	},
	subscribeButton: {
		id: 'uniform.emailSubscriptionForm.subscribeButton',
		defaultMessage: 'Subscribe',
	},
	privacyAgreement: {
		id: 'uniform.emailSubscriptionForm.privacyAgreement',
		defaultMessage:
			'By signing up on this form, I acknowledge Atlassian’s <link>Privacy Policy</link>.',
	},
	marketingOptIn: {
		id: 'uniform.emailSubscriptionForm.marketingOptIn',
		defaultMessage:
			'Yes, I would like to receive promotional emails including product news, events, and more from <atlassianLink>Atlassian</atlassianLink> and <partnersLink>Atlassian Partners</partnersLink>.',
	},
	invalidEmail: {
		id: 'uniform.emailSubscriptionForm.validation.invalidEmail',
		defaultMessage: 'Please provide a valid email address',
	},
	unexpectedError: {
		id: 'uniform.emailSubscriptionForm.validation.unexpectedError',
		defaultMessage: 'An unexpected error occurred',
	},
	success: {
		id: 'uniform.emailSubscriptionForm.success',
		defaultMessage:
			'You are now subscribed! Your email preferences can be updated in your Atlassian account settings.',
	},
});
